import { Button } from "antd";
import { useState, useEffect } from "react";

interface OTPCountdownProps {
  expiryMinutes: number;
  onResend: () => void;
  isSendingOtp: boolean;
  start: boolean;
  setStart: any;
}

export default function OTPCountdown({
  expiryMinutes,
  onResend,
  isSendingOtp,
  start,
  setStart,
}: OTPCountdownProps) {
  const [timeLeft, setTimeLeft] = useState(expiryMinutes * 60);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    if (start && !isSendingOtp) {
      setTimeLeft(expiryMinutes * 60);
      setHasStarted(true);
    }
  }, [start, expiryMinutes, isSendingOtp]);

  useEffect(() => {
    if (!hasStarted || timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, hasStarted]);

  const formatTime = (seconds: any) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (mins > 0) {
      return `${mins} ${mins === 1 ? "min" : "mins"}`;
    }
    return `${secs} ${secs === 1 ? "second" : "seconds"}`;
  };

  const handleResend = () => {
    setHasStarted(false);
    setStart(false);
    onResend();
  };

  return (
    <div className="my-1">
      {hasStarted && timeLeft > 0 ? (
        <p className="text-gray-600 text-sm">
          Your OTP will expire in{" "}
          <span className="font-semibold">{formatTime(timeLeft)}</span>
        </p>
      ) : (
        <p className="text-gray-600 text-sm">
          <div className=" flex items-center gap-2 justify-end">
            {hasStarted && timeLeft === 0 ? "OTP expired" : "OTP expired ?"}
            <Button
              disabled={isSendingOtp}
              loading={isSendingOtp}
              className="!p-1 !h-auto !min-h-fit !border-none"
              onClick={handleResend}
            >
              Resend OTP
            </Button>
          </div>
        </p>
      )}
    </div>
  );
}
